import { TransformInt } from '../../../shared/decorators/transform-int.decorator';
import { DayOfWeekEnum } from '../../../shared/enums/day-of-week.enum';

/**
 * Update proto settings DTO
 */
export class UpdateProtoSettingsDto {
	@TransformInt()
	id!: number;
	color?: string;

	shortDateFormat?: string;
	shortTimeFormat?: string;
	longDateFormat?: string;
	longTimeFormat?: string;
	firstDayOfWeek?: DayOfWeekEnum;

	@TransformInt()
	amountDecimalDigits?: number;
	amountDecimalSeparator?: string;
	amountGroupSeparator?: string;
}
